import { useStateOfPriceFilter } from '@/hooks/useStateOfPriceFilter';
import _get from 'lodash/get';
import { MIN_SLIDER_VALUE } from '@/constants/common.constants';
import PriceFilterStore from '@tajawal/web-flights-sdk/lib/stores/filter/price-filter.store';
import { pushFilterChangeGtmEvent } from '@/utils/avoGtm.utils';
import { FILTER_MAP } from '@tajawal/web-flights-sdk/lib/constants/filters.constants';

function usePriceFilter(filter: PriceFilterStore) {
  const { state, isDirty, set, reset, uncommittedState, commit, formatPriceWithDecimals } =
    useStateOfPriceFilter(filter);
  const minValue = _get(state, 'min', MIN_SLIDER_VALUE);
  const maxValue = _get(state, 'max', MIN_SLIDER_VALUE);
  const currency = _get(state, 'currency');
  const currentValue = [uncommittedState.from, uncommittedState.to];
  function handleChange(_event: Event, newValue: number) {
    set({
      from: minValue,
      to: newValue,
    });
  }

  function handleReset() {
    reset(true);
  }

  function handleChangeCommit() {
    commit();
    pushFilterChangeGtmEvent(FILTER_MAP.PRICE, JSON.stringify({ minValue, maxValue, currency }));
  }

  return {
    state,
    isDirty,
    set,
    reset,
    uncommittedState,
    commit,
    formatPriceWithDecimals,
    minValue,
    maxValue,
    currency,
    currentValue,
    handleChange,
    handleReset,
    handleChangeCommit,
  };
}

export default usePriceFilter;
